/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Dok_NInputs */

const en_tut_dok_n = /** @type {(inputs: Tut_Dok_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The limit is 50,000 characters per document. If the connection drops, the page says so and offers **Unduh draf Markdown** — keep the tab open until it reconnects. Agents can also draft documents through **Buat dengan agen**, which spends the workspace AI quota.`)
};

const id_tut_dok_n = /** @type {(inputs: Tut_Dok_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batasnya: 50.000 karakter per dokumen. Kalau koneksi terputus, halaman memberi tahu dan menyediakan **Unduh draf Markdown** — biarkan tab terbuka sampai tersambung lagi. Agen juga bisa menyusun dokumen lewat **Buat dengan agen**, dan itu memakai kuota AI workspace.`)
};

/**
* | output |
* | --- |
* | "The limit is 50,000 characters per document. If the connection drops, the page says so and offers **Unduh draf Markdown** — keep the tab open until it reconn..." |
*
* @param {Tut_Dok_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_dok_n = /** @type {((inputs?: Tut_Dok_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Dok_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_dok_n(inputs)
	return en_tut_dok_n(inputs)
});